import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import Head from '../../components/Partials/Head/Head';
import Auxiliary from '../../hoc/Auxiliary';
import TextGroup from '../../components/TextGroup/TextGroup';
import ProductBanner from '../../components/ProductBanner/ProductBanner';
import ProductSection from '../../components/ProductSection/ProductSection';
import HighlightBanner from '../../components/HighlightBanner/HighlightBanner';
class Perceptum extends Component {

  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="perceptum" />
        <ProductBanner  {...this.props} page="perceptum" />
        <ProductSection noPadTitle noPadBottom {...this.props} page="perceptum" section="functionalities">
          <TextGroup noBtnPadding  {...this.props} page="perceptum" section="functionalities" />
        </ProductSection>
        <ProductSection noPadTop noPadTitle noPadBottom noTitle  {...this.props} page="perceptum" section="functionalities">
          <HighlightBanner {...this.props} location="products" page="perceptum" section="advantages">
            <TextGroup {...this.props} page="perceptum" section="advantages" />
          </HighlightBanner>
        </ProductSection>
        <ProductSection noPadTitle {...this.props} page="perceptum" section="compatiblities">
          <TextGroup {...this.props} page="perceptum" section="compatiblities" />
          <TextGroup {...this.props} noPadBottom page="perceptum" section="demo" />
        </ProductSection>
      </Auxiliary>
    )
  }
}

export default withTranslation()(Perceptum);